import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'section-e',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './section-e.component.html',
  styleUrl: './section-e.component.css'
})
export class SectionEComponent implements OnInit, OnChanges {

  @Input() fullTeamAssessmentData: any;
  @Output() onSaveSection7 = new EventEmitter<any>();

  yesNo = EYesNo;
  sectionEForm: FormGroup = new FormGroup([]);

  radioQuestions = [    
    {
      id: 'hopelessness_desperation',
      questionText: 'Is there information to suggest that the student is experiencing hopelessness, desperation or despair? *',
      formControlName: 'hopelessness_desperation',
      infoFormControlName: 'hopelessness_desperation_information',
      label: 'Please explain: *'
    },
    {
      id: 'substance_abuse',
      questionText: "Substance abuse? *",
      formControlName: 'substance_abuse',
      infoFormControlName: 'substance_abuse_information',
      label: 'Please explain: *'
    },
    {
      id: 'mental_health_diagnosis',
      questionText: 'A known mental health diagnosis? *',
      formControlName: 'mental_health_diagnosis',
      infoFormControlName: 'mental_health_diagnosis_information',
      label: 'Please explain: *'
    },
    {
      id: 'recent_failure',
      questionText: 'Recent failure, loss, and/or loss of status? *',
      formControlName: 'recent_failure',
      infoFormControlName: 'recent_failure_information',
      label: 'Please explain: *'
    },
    {
      id: 'emotional_trauma',
      questionText: 'Othere emotional trauma? *',
      formControlName: 'emotional_trauma',
      infoFormControlName: 'emotional_trauma_information',
      label: 'Please explain: *'
    },
    {
      id: 'stressful_events',
      questionText: 'Difficulty coping with stressful events? *',
      formControlName: 'stressful_events',
      infoFormControlName: 'stressful_events_information',
      label: 'Please explain: *'
    },
    {
      id: 'suicidal_tendencies',
      questionText: 'Suicidal tendencies/ideation? *',
      formControlName: 'suicidal_tendencies',
      infoFormControlName: 'suicidal_tendencies_information',
      label: 'Please explain: *'
    },
    {
      id: 'mental_health_hospitalization',
      questionText: 'Hospitalized for mental health reasons? *',
      formControlName: 'mental_health_hospitalization',
      infoFormControlName: 'mental_health_hospitalization_information',
      label: 'Please explain: *'
    },
    {
      id: 'paranoid_thinking',
      questionText: 'Paranoid thinking? *',
      formControlName: 'paranoid_thinking',
      infoFormControlName: 'paranoid_thinking_information',
      label: 'Please explain: *'
    },
    {
      id: 'obsessive_thoughts',
      questionText: 'Obsessive thoughts? *',
      formControlName: 'obsessive_thoughts',
      infoFormControlName: 'obsessive_thoughts_information',
      label: 'Please explain: *'
    },
    {
      id: 'homicidal_ideation',
      questionText: 'Homicidal ideation? *',
      formControlName: 'homicidal_ideation',
      infoFormControlName: 'homicidal_ideation_information',
      label: 'Please explain: *'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fullTeamAssessmentData'] && this.fullTeamAssessmentData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      group[question.formControlName] = new FormControl(String(this.fullTeamAssessmentData?.[question.formControlName]) || this.yesNo.No, Validators.required);
      group[question.infoFormControlName] = new FormControl({ value: this.fullTeamAssessmentData?.[question.infoFormControlName] || '', disabled: this.fullTeamAssessmentData?.[question.infoFormControlName] ? false: true });
    });
    group['e_additional_info'] = new FormControl(String(this.fullTeamAssessmentData?.e_additional_info) || this.yesNo.No, Validators.required);

    this.sectionEForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.sectionEForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.sectionEForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }
        });
      }
    });
  }

  saveSectionE(): void {
    if (this.sectionEForm.valid) {
      this.onSaveSection7.emit(this.sectionEForm.value);
    }
  }

}
